import { render, staticRenderFns } from "./PublicatorRow.vue?vue&type=template&id=d03f9f4e&scoped=true"
import script from "./PublicatorRow.vue?vue&type=script&lang=js"
export * from "./PublicatorRow.vue?vue&type=script&lang=js"
import style0 from "./PublicatorRow.vue?vue&type=style&index=0&id=d03f9f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03f9f4e",
  null
  
)

export default component.exports